import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';
import { BehaviorSubject } from 'rxjs';
import { ActorActionEnum } from 'src/app/constants/actor-action.enum';
import { DocumentActor } from 'src/app/models/actors';
import { SignatureField } from 'src/app/models/signaturefield';
import { ViewerDataService } from '../viewer-data.service';
import { ExistsIn } from 'src/app/_helpers/ArrayExtensionMethodHelper.functions';

@Component({
  selector: 'app-performactiondocumentpdfimage',
  templateUrl: './performactiondocumentpdfimage.component.html'
})

export class PerformActionDocumentPdfImageComponent implements OnInit {

  @Input('source') source!: SafeUrl | null | undefined;
  @Input('x') x!: number;
  @Input('y') y!: number;
  @Input('signatureFields') signatureFields: any[] = [];
  @Input('actionsOtherActors') actionsOtherActors: DocumentActor[] = [];
  @Input('pId') pId: number = 0;
  @Input('docId') docId!: string;
  @Input('status') status!: string;
  @Input('active') active!: number;
  @Input('buttonsEnabled') buttonsEnabled!: BehaviorSubject<boolean>;
  @Input('actions') actions: DocumentActor[] = [];
  @Output('sign') signEmitter = new EventEmitter;
  width: number = 100;
  positionSignatureField!: any;
  pageWidth: number = 0;
  pageHeight: number = 0;
  viewerWidth: number = 0;
  private _zoomFactor!: number;

  constructor(private viewerDataService: ViewerDataService){

  }
  
  /**
   * Get width and height if zoomfactor is change. Width and height of signaturefields must be changed too.
   */
  @Input() set zoomFactor(value: number) {
    this._zoomFactor = value;
    this.getWidthAndHeightCurrentPage(this.docId + "_" + this.pId + "_signaturePage");
  }
  get zoomFactor(): number {
     return this._zoomFactor;
  }

  get getOtherActorsPlaceholders(): DocumentActor[] {
    return this.actionsOtherActors ? this.actionsOtherActors.filter(x => !x.hasSigned) : [];
  }
  @HostListener('window:resize') async onScroll() {
    // Get current width and height of page. Needed for placeholder location calculation.
    this.getWidthAndHeightCurrentPage(this.docId + "_" + this.pId + "_signaturePage");
  }


  async ngOnInit(): Promise<void> {
    setTimeout(() => {
      this.getWidthAndHeightCurrentPage(this.docId + "_" + this.pId + "_signaturePage");
    }, 100);
  }

  public async Sign(signatureField: SignatureField) {
    this.buttonsEnabled.next(false);
    let signAction: any = {
      action: ActorActionEnum.Sign,
      documentId: this.docId,
      inviteGuid: signatureField.id
    };
    this.signEmitter.emit(signAction);
  }

  getAcronym(signature: any) {
    let matches: any = signature.fullName.match(/\b(\w)/g);
    return matches.join('');
  }

  currentActionIsThisAction(signatureField: SignatureField) {
    return this.actions.filter(s => !s.hasSigned).length > 0 ? this.actions.filter(s => !s.hasSigned)[0].id === signatureField.id : false;
  }

  getRightYPosition() {
    let height: number = this.y;
    if (document.getElementById(this.docId + '_' + this.pId + '_indicator') !== null && document.getElementById(this.docId + '_' + this.pId + '_indicator') !== undefined && document.getElementById(this.docId + '_' + this.pId + '_indicator')!.clientWidth && this.x) height = this.y / 100 * (document.getElementById(this.docId + '_' + this.pId + '_indicator')!.clientWidth / this.x * 100);
    return height;
  }

  getWidthAndHeightCurrentPage(pageElement: any) {
    let positionSignatureField = document.getElementById(pageElement)!;
    this.pageWidth = positionSignatureField?.offsetWidth;
    this.pageHeight = positionSignatureField?.offsetHeight;
    this.viewerWidth = window.innerWidth;
  }

  checkIfSignatureFieldIsInLockedDocument(signatureField: SignatureField) {
    return (ExistsIn(this.viewerDataService.listOfToastsWithLockedDocuments, "Guid", signatureField.documentId) || ExistsIn(this.viewerDataService.listOfLockedDocumentsWithoutToasties, "Guid", signatureField.documentId));
  }

  createSpecialFieldId(documentId :string, fieldName:string) :string{
    let expectedFieldName = this.viewerDataService.createSigningFieldId(documentId, fieldName);
    return expectedFieldName;
  }

}
